import React from 'react';
import { Button } from 'reactstrap';
import { connect } from 'react-redux';


import { getFileFromS3 } from '../../../views/common/downloadSourcesOperations';

//Scripts auxiliares:
import { registerAuditProcess } from '../../../tools/scripts/customFetching';
let dateFormatter = require('../../../tools/formatters/dateFormatter');

let FileButton = (props) => {
    if (props.color === undefined) {
        return (
            <Button
                className="btn btn-default"
                disabled={getDisabledValue(props)}
                onClick={() => { downloadFile(props) }}
                style={{ padding: "8px 15px", backgroundColor: "transparent", color: "#65615c", marginLeft: 10 }}>
                <i className="far fa-file-alt"></i>
            </Button>
        );
    }
    else {
        return (
            <Button
                color={props.color}
                disabled={getDisabledValue(props)}
                onClick={() => { downloadFile(props) }}>
                Descargar fichero
            </Button>
        );
    }
}

let downloadFile = (props) => {
    let targetProcessId = props.targetProcess.id;
    let targetSourceId = props.targetProcess.source_id;
    if (props.activeUser.is_admin || props.activeUser.is_staff) {
        let output_type = props.targetProcess.whole_config.output_type;
        if(output_type === "s3"){
            getFileFromS3(props, props.targetProcess, registerAuditProcess, (presignedUrl) => {  
                window.open(presignedUrl);
            });
        }else{
            window.open(process.env.REACT_APP_API_URL + "/sources/" + targetSourceId + "/processes/" + targetProcessId + "/get_file", "_blank");
        }
        registerAuditProcess(props, {
            "event_type": "FILE_DOWNLOADED",
            "description": "El usuario <b>descargó el fichero</b> de la fuente "
                + props.targetProcess.linkedDownloadSource.description.replace(":", ": ")
                + " generado en " + dateFormatter.getCompoundDate(new Date(props.targetProcess.created))
        });
    }
}

let getDisabledValue = (props) => {
    const allowErrorDownload = props.targetProcess?.whole_config?.allow_download_on_error === true;
    const validStatuses = ["SUCCESS", "WARNING"];
    if (allowErrorDownload) {
        validStatuses.push("ERROR");
    }
    return !(props.userCanClickTheButton && validStatuses.includes(props.targetProcess.status));
}

const mapStateToProps = state => {
    return {
        activeUser: state.mainReducer.activeUser,
        coreBackendHost: state.mainReducer.coreBackendHost,
        enableAuditRegistering: state.mainReducer.enableAuditRegistering
    };
};

export default connect(mapStateToProps)(FileButton);